"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openPageAnalyticsModal = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var PageStatusIcon_1 = require("@CommonFrontend/Project/PageStatusIcon");
var PageAnalyticsSumary_1 = require("./Summary/PageAnalyticsSumary");
var SessionView_1 = require("./SessionView/SessionView");
var UsePageEngagement_1 = require("Common/Engagement/PageEngagementPopover/UsePageEngagement");
var EngagementPill_1 = require("Common/Engagement/EngagementPill");
var Types_1 = require("@CommonFrontend/Modal/Types");
var ModalComponent_1 = __importDefault(require("@CommonFrontend/Modal/ModalComponent"));
var DIProvider_1 = require("@CommonFrontend/DIProvider/DIProvider");
var SharePopover_1 = require("Project/SharePopover/SharePopover");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var Util_1 = require("@CommonFrontendBackend/Permissions/Util");
var Types_2 = require("@CommonFrontendBackend/Permissions/Types");
var Types_3 = require("@CommonFrontendBackend/Projects/Types");
var PageValue_1 = require("./Components/PageValue");
var styles = __importStar(require("./PageAnalytics.css"));
function openPageAnalyticsModal(di, projectStore, onStateClose, eventOrigin, pageViewId) {
    return __awaiter(this, void 0, Promise, function () {
        function onModalClose(useOnStateClose) {
            if (modalRoot) {
                react_dom_1.default.unmountComponentAtNode(modalRoot);
            }
            if (useOnStateClose) {
                onStateClose.onClose();
            }
        }
        var modalRoot;
        return __generator(this, function (_a) {
            modalRoot = document.getElementById(Types_1.modalRootId);
            react_dom_1.default.render(react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
                react_1.default.createElement(ModalComponent_1.default, { containerClassName: styles.modalContainer, contentClassName: styles.modalContent, isEscapable: false },
                    react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.overlayStackZIndex }, function () { return (react_1.default.createElement(PageAnalytics, { projectStore: projectStore, onModalClose: onModalClose, eventOrigin: eventOrigin, pageViewId: pageViewId })); }))), modalRoot);
            return [2];
        });
    });
}
exports.openPageAnalyticsModal = openPageAnalyticsModal;
var PageAnalytics = (0, mobx_react_1.observer)(function (_a) {
    var projectStore = _a.projectStore, onModalClose = _a.onModalClose, eventOrigin = _a.eventOrigin, pageViewId = _a.pageViewId;
    var pageId = projectStore._id, name = projectStore.name, status = projectStore.status, createdAt = projectStore.createdAt, userAction = projectStore.userAction, cachedPageValue = projectStore.cachedPageValue, currencyLocale = projectStore.currencyLocale;
    var _b = __read((0, react_1.useState)(0), 2), timePeriodOffset = _b[0], setTimePeriodOffset = _b[1];
    var _c = __read((0, react_1.useState)(function () {
        return pageViewId ? { viewer: { id: pageViewId, idType: "pageViewId" } } : null;
    }), 2), sessionViewState = _c[0], setSessionViewState = _c[1];
    var _d = (0, UsePageEngagement_1.usePageEngagement)(pageId, { autoRevalidate: true }), engagement = _d.engagement, isEngagementLoading = _d.isLoading;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var projectAuditInspector = (0, inversify_react_1.useInjection)("projectAuditInspector");
    var _e = __read((0, react_1.useState)(undefined), 2), summaryEmptyState = _e[0], setSummaryEmptyState = _e[1];
    (0, react_1.useEffect)(function () {
        var pageAnalyticsStartViewTime = new Date().getTime();
        if (summaryEmptyState !== undefined) {
            serverTelemetry.sendPageAnalyticsTelemetry({
                eventName: event_tracker_types_1.EventName.PageAnalyticsViewed,
                eventOrigin: eventOrigin,
                isEmptyState: summaryEmptyState,
            });
        }
        return function () {
            var viewTime = Math.floor((new Date().getTime() - pageAnalyticsStartViewTime) / 1000);
            serverTelemetry.sendPageAnalyticsTelemetry({
                eventName: event_tracker_types_1.EventName.PageAnalyticsClosed,
                eventOrigin: eventOrigin,
                pageAnalyticsViewTime: viewTime,
            });
        };
    }, [summaryEmptyState]);
    var isAdmin = rootDataStore.userDataStore.isAdmin;
    var timeZone = rootDataStore.getAccountDataStore().getAccountTimezone();
    var isPageEditable = (0, Util_1.isAtLeast)(userAction, Types_2.Action.Edit) && (0, Utils_1.isActionAllowed)(status, Types_3.ProjectActions.Edit);
    var collaboratorPageUrl = projectStore.getCollaboratorPageUrl();
    var renderSharePopover = function (initialMenu) { return (react_1.default.createElement(SharePopover_1.SharePopover, { projectStore: projectStore, source: TelemetryEnums_1.TelemetrySource.PageAnalytics, usingFeature: usingFeature, initialMenu: initialMenu })); };
    var openAuditTrailOverlay = function () { return projectAuditInspector.inspect(projectStore); };
    return (react_1.default.createElement("div", { className: styles.navAndContentGrid },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.navBar, direction: "horizontal", align: "center", justify: "spaceBetween", gap: { tablet: "m" }, paddingLeft: { tablet: "m", laptop: "l" }, paddingRight: { tablet: "m", laptop: "l" } },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.navBarLeft, direction: "horizontal", align: "center", gap: { default: "xxxs", tablet: "m" } },
                sessionViewState ? (react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.headerIcon, icon: react_1.default.createElement(icons_1.ArrowLeft, null), onClick: function () { return setSessionViewState(null); } })) : (react_1.default.createElement(icons_1.Analytics, { className: styles.headerIcon, size: icons_1.IconSize.Large })),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.navHeadingText, direction: "horizontal", align: "center", gap: "xxs" },
                    react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, secondary: !!sessionViewState, level: "4" }, "Analytics"),
                    sessionViewState && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(icons_1.ChevronRight, { color: "default" }),
                        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "4" }, "Session")))),
                react_1.default.createElement("div", { className: styles.verticalDivider }),
                react_1.default.createElement(kaleidoscope_1.Link, { className: styles.pageName, href: collaboratorPageUrl },
                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, name))),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "end", gap: { default: "xxxs", tablet: "m" } },
                react_1.default.createElement(EngagementPill_1.EngagementPill, { engagementLevel: engagement === null || engagement === void 0 ? void 0 : engagement.level, isCalculating: isEngagementLoading }),
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xxs" },
                    react_1.default.createElement(PageStatusIcon_1.PageStatusIcon, { status: status }),
                    react_1.default.createElement(kaleidoscope_1.Label, null, (0, Utils_1.pageStatusDisplayText)(status))),
                react_1.default.createElement(PageValue_1.PageValue, { cachedPageValue: cachedPageValue, currencyLocale: currencyLocale }),
                react_1.default.createElement(kaleidoscope_1.Button, { className: styles.viewPageButton, href: function () { return collaboratorPageUrl; }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "View page"),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: function () { return onModalClose(true); } }))),
        sessionViewState ? (react_1.default.createElement(SessionView_1.SessionView, { pageId: pageId, viewer: sessionViewState.viewer, initialPageViewId: sessionViewState.initialPageViewId, renderSharePopover: renderSharePopover, closeModal: function () { return onModalClose(false); }, isAdmin: isAdmin, isPageEditable: isPageEditable, timeZone: timeZone, openAuditTrailOverlay: openAuditTrailOverlay })) : (react_1.default.createElement(PageAnalyticsSumary_1.PageAnalyticsSummary, { pageId: pageId, pageStatus: status, isPageEditable: isPageEditable, pageCreationDate: new Date(createdAt), allTimeViewCount: projectStore.totalLinkViews || 0, timeZone: timeZone, timePeriodOffset: timePeriodOffset, isAdmin: isAdmin, setTimePeriodOffset: setTimePeriodOffset, renderSharePopover: renderSharePopover, openSession: function (viewer, pageViewId) { return setSessionViewState({ viewer: viewer, initialPageViewId: pageViewId }); }, closeModal: function () { return onModalClose(false); }, openAuditTrailOverlay: openAuditTrailOverlay, setSummaryEmptyState: setSummaryEmptyState }))));
});
